import { render } from "../../templates/partner-cart-legal-details.html?vue&type=template&id=40d54596"
import script from "./legal-details.vue?vue&type=script&lang=js"
export * from "./legal-details.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__